import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';

import ListHeader from '../../shared/components/list_view/ListHeader';
import TicketGridContainer from '../containers/TicketGridContainer';
import SortPanelContainer from '../containers/SortPanelContainer';
import FilterPanelContainer from '../containers/FilterPanelContainer';
import ExportPanelContainer from '../containers/ExportPanelContainer';
import {
  PositioningContainer,
  ModalPanel,
  Overlay
} from '../../shared/components/styles';

// top level container for list
class TicketList extends React.Component {
  render() {
    const {
      isExportExpanded,
      isFilterExpanded,
      isSortExpanded,
      isFieldSelectionExpanded
    } = this.props;
    const props = this.props;
    return (
      <Section className={clsx(props.className, 'ticket-list')}>
        <ListHeader {...props} />
        <PositioningContainer>
          <ModalPanel
            show={isFilterExpanded}
            onClick={e => e.stopPropagation()}>
            {isFilterExpanded && <FilterPanelContainer {...props} />}
          </ModalPanel>
          <ModalPanel show={isSortExpanded} onClick={e => e.stopPropagation()}>
            {isSortExpanded && <SortPanelContainer {...props} />}
          </ModalPanel>
          <ModalPanel
            show={isExportExpanded}
            onClick={e => e.stopPropagation()}>
            {isExportExpanded && (
              <ExportPanelContainer fieldSelectionOnly={false} {...props} />
            )}
          </ModalPanel>
          <ModalPanel
            show={isFieldSelectionExpanded}
            onClick={e => e.stopPropagation()}>
            {isFieldSelectionExpanded && (
              <ExportPanelContainer fieldSelectionOnly {...props} />
            )}
          </ModalPanel>
          <Overlay
            show={
              isFilterExpanded ||
              isSortExpanded ||
              isExportExpanded ||
              isFieldSelectionExpanded
            }
          />
          <div className="list-container">
            {/* we used to have a switch here to display the infinite list, but we don't need it anymore */}
            <TicketGridContainer {...props} />
          </div>
        </PositioningContainer>
      </Section>
    );
  }
}

// position the loading spinner under the modals
const Section = styled.section`
  .spinner-container {
    z-index: 15;
  }
  display: flex;
  flex-direction: column;
  // want to span the whole height.
  // For some reason 100% does not work on iOS
  height: 100vh;
  & > header {
    flex: 0 0 auto;
  }
  & > div {
    flex: 1;
    .list-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
    }
  }
`;

TicketList.propTypes = {
  totalCount: PropTypes.number.isRequired,
  records: PropTypes.array.isRequired,
  isFilterExpanded: PropTypes.bool.isRequired,
  isFilterActive: PropTypes.bool.isRequired,
  isFieldSelectionExpanded: PropTypes.bool.isRequired,
  isExportExpanded: PropTypes.bool.isRequired,
  isSortExpanded: PropTypes.bool.isRequired
};

export default TicketList;

// vim ft=javascript.jsx
